const tableConf = [
  {
    isSortable: true,
    field: 'createdDate',
    title: 'Create Date'
  },
  {
    isSortable: false,
    field: 'userCompanyEmail',
    title: 'User Company Email'
  },
  {
    isSortable: false,
    field: 'actionUserEmail',
    title: 'Action User Email'
  },
  {
    isSortable: false,
    field: 'activity',
    title: 'Activity'
  },
  {
    isSortable: true,
    field: 'activityType',
    title: 'Activity Type'
  },
  {
    isSortable: true,
    field: 'arrChanged',
    title: 'ARR',
    fromToGroup: true
  },
  {
    isSortable: true,
    field: 'arrStatus',
    title: 'Status',
    show: true,
    width: 120,
    valuesExport: ['status']
  },
  {
    isSortable: true,
    field: 'lastUpdate',
    title: 'Updated date',
    show: true,
    width: 122,
    valuesExport: ['lastUpdate']
  }
];

const exportConfig = {
  exportUrl: '/customer/arractivity/export',
  exportFormat: 'zip'
};

export { tableConf, exportConfig };
